<div *ngIf="etatOuvrages.length === 0">
	{{ ouvrageNoms | truncate:[24, '...'] }}
</div>
<div *ngIf="etatOuvrages.length > 0">
	<ng-container *ngFor="let etatOuvrage of etatOuvrages; let index = index;">
		<span *ngIf="index > 0">, </span>
		<span [style.color]="etatOuvrage.color">{{ etatOuvrage.ouvrage }}</span>
	</ng-container>
</div>